import axios from ".";

/** Fetch all generic module statuses (Module 1). */
export const getAllStatus = () => {
  return axios({
    method: "GET",
    url: "/api/modules/1/statuses",
  });
};
/** Fetch Key Result statuses (Module 2). */
export const getAllStatusForKeyResults = () => {
  return axios({
    method: "GET",
    url: "/api/modules/2/statuses",
  });
};
/** Fetch Initiative statuses (Module 3). */
export const getAllStatusForInitiatives = () => {
  return axios({
    method: "GET",
    url: "/api/modules/3/statuses",
  });
};

/** Fetch Milestone statuses (Module 4). */
export const getAllStatusForMilestones = () => {
  return axios({
    method: "GET",
    url: "/api/modules/4/statuses",
  });
};

/** Search employees with filters/pagination. */
export const getAllEmployees = (params?: any) => {
  return axios({
    method: "POST",
    url: "/employees/search",
    data: params,
  });
};

/** Return milestones by filter for dashboard widgets. */
export const getUpcomingMilestones = (data?: any) => {
  return axios({
    method: "POST",
    url: "/milestone/milestones",
    data,
  });
};

/** Return upcoming milestones. */
export const getUpcomingMilestonesUpdated = (data?: any) => {
  return axios({
    method: "POST",
    url: "/milestone/upcoming-milestones",
    data,
  });
};

/** Fetch all departments (static list). */
export const getAllDepartments = () => {
  return axios({
    method: "POST",
    url: "api/departments",
    data: [],
  });
};
/** Years available for Initiatives filtering. */
export const getAllYearsForInitiatives = () => {
  return axios({
    method: "GET",
    url: "/initiative/years",
  });
};
/** Years available for Objectives filtering. */
export const getAllYearsForObjectives = () => {
  return axios({
    method: "GET",
    url: "/objective/years",
  });
};
